export const FREEMIUM_ID = 237845
export const SCHOOL_SOMOS_EDUCACAO = 64781
export const SEDUC_SP_ROOT_ID = 550750
